<template>
  <div class="room gas-clamp">
    <refresh-block @refreshData="refreshData"></refresh-block>
    <div class="main-cable up-stream">
      <div class="cable-title">
        <h2>上游主缆</h2>
      </div>
      <div
        class="cable-main"
        v-loading="loading"
      >
        <div class="legend">
          <div class="supply">进气夹</div>
          <div class="exhaust">排气夹</div>
        </div>
        <div class="cable-img">
          <div
            class="clip"
            :class="[item.className,`ex${$index+1}`]"
            :title="item.name"
            :key="`top-item-${$index}`"
            v-for="(item,$index) in topList"
          >
            <div
              class="state-info"
              :class="[item.opsName,item.errorLevel]"
            >
              <p class="airHumidity">{{item.list[0].value}}%</p>
              <p class="airTemperature">{{item.list[1].value}}°C</p>
              <p class="airPressure">{{item.list[2].value}}Pa</p>
              <p
                class="airFlow"
                v-if="item.list[3]"
              >{{item.list[3].value}}m³/h</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-cable up-stream">
      <div class="cable-title">
        <h2>下游主缆</h2>
      </div>
      <div
        class="cable-main"
        v-loading="loading"
      >
        <div class="legend">
          <div class="supply">进气夹</div>
          <div class="exhaust">排气夹</div>
        </div>
        <div class="cable-img">
          <div
            class="clip"
            :class="[item.className,`ex${$index+1}`]"
            :title="item.name"
            :key="`bottom-item-${$index}`"
            v-for="(item,$index) in bottomList"
          >
            <div
              class="state-info"
              :class="[item.opsName,item.errorLevel]"
            >
              <p class="airHumidity">{{item.list[0].value}}%</p>
              <p class="airTemperature">{{item.list[1].value}}°C</p>
              <p class="airPressure">{{item.list[2].value}}Pa</p>
              <p
                class="airFlow"
                v-if="item.list[3]"
              >{{item.list[3].value}}m³/h</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
export default {
  name: 'gasClamp',
  data () {
    return {
      loading: true,
      deviceList: [
        { stationId: '9975ea8e-e227-4d89-aaac-d583f1fa1c58', stationName: '5#制备站气夹' },
        { stationId: '5423cf90-2511-4070-aac9-2bb64f15f0a3', stationName: '6#制备站气夹' }
      ],
      topList: [
        {
          name: '5#制备站上游边跨排气夹2',
          className: 'exhaust',
          opsName: 'left-pos',
          errorLevel: '',
          list: [
            { deviceId: '299b49d3-71d6-4559-b27f-9855c3a9b85c', deviceName: '上游边跨排气夹2送气湿度', value: null },
            { deviceId: '5aa76787-cbe4-4e63-9245-d8de67d7f32e', deviceName: '上游边跨排气夹2送气温度', value: null },
            { deviceId: '72dcabae-f8d4-43b8-982f-3d7f50054b72', deviceName: '上游边跨排气夹2送气压力', value: null }
          ]
        },
        {
          name: '5#制备站上游边跨进气夹',
          className: 'supply',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            { deviceId: 'cddcdf84-b46f-42ed-abb9-15da48a3a9d1', deviceName: '上游边跨进气夹送气湿度', value: null },
            { deviceId: '877d9de6-bcf6-4ab7-a41d-5520b40446d0', deviceName: '上游边跨进气夹送气温度', value: null },
            { deviceId: '0e89ce8d-7d03-45e8-9759-9d1033381723', deviceName: '上游边跨进气夹送气压力', value: null },
            { deviceId: '52abee53-5006-4c0e-8bea-865db276c84e', deviceName: '上游边跨进气夹送气流量', value: null }
          ]
        },
        {
          name: '5#制备站上游边跨排气夹1',
          className: 'exhaust',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            { 'deviceId': '5b917372-9dd4-408f-8d21-27cd6aad443b', 'deviceName': '上游边跨排气夹1送气湿度', value: null },
            { 'deviceId': '748208ac-0585-4f50-b5d1-6a3fe0de0c1e', 'deviceName': '上游边跨排气夹1送气温度', value: null },
            { 'deviceId': '1b48db8a-09a8-4ced-8bd4-5869193e44bb', 'deviceName': '上游边跨排气夹1送气压力', value: null }
          ]
        },
        {
          name: '5#制备站上游中跨排气夹1',
          className: 'exhaust',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            { 'deviceId': 'b37d54ce-ac8f-4170-8f28-613c910f412a', 'deviceName': '上游中跨排气夹1送气湿度', value: null },
            { 'deviceId': '67b4d202-b947-409c-a0c8-bbfcd50159f5', 'deviceName': '上游中跨排气夹1送气温度', value: null },
            { 'deviceId': '51c80dc9-ef75-42f7-8029-2792424c8156', 'deviceName': '上游中跨排气夹1送气压力', value: null }
          ]
        },
        {
          name: '5#制备站上游中跨进气夹1',
          className: 'supply',
          opsName: 'left-pos',
          errorLevel: '',
          list: [
            { 'deviceId': '6aabb052-ce4d-40d3-8f84-711c7f219d4f', 'deviceName': '上游中跨进气夹1送气湿度', value: null },
            { 'deviceId': 'a69cff61-1527-432a-8dfb-df6398770b31', 'deviceName': '上游中跨进气夹1送气温度', value: null },
            { 'deviceId': '56e49b16-f189-4d1e-aadc-e571628ce863', 'deviceName': '上游中跨进气夹1送气压力', value: null },
            { 'deviceId': '22e28ab1-768a-4c29-a2a8-ff4ff4e1b78b', 'deviceName': '上游中跨进气夹1送气流量', value: null }
          ]
        },
        {
          name: '5#制备站上游中跨排气夹2',
          className: 'exhaust',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            { 'deviceId': '73f6a1fd-9316-4a02-abb5-b7a59025d0f1', 'deviceName': '上游中跨排气夹2送气湿度', value: null },
            { 'deviceId': '27d6f6e9-14f1-4cab-92db-8ee5243b2a12', 'deviceName': '上游中跨排气夹2送气温度', value: null },
            { 'deviceId': '7474452a-5baf-409e-8525-d0f76b2b85a1', 'deviceName': '上游中跨排气夹2送气压力', value: null }
          ]
        },
        {
          name: '5#制备站上游中跨进气夹2',
          className: 'supply',
          opsName: 'left-pos',
          errorLevel: '',
          list: [
            { 'deviceId': 'fd7ce8de-b431-4912-9457-1e13f48aef75', 'deviceName': '上游中跨进气夹2送气湿度', value: null },
            { 'deviceId': '8468d740-09fe-47ea-b0d6-8ba005f1ffb3', 'deviceName': '上游中跨进气夹2送气温度', value: null },
            { 'deviceId': '7870c2c6-eba8-42bd-a15f-92df1d9e2235', 'deviceName': '上游中跨进气夹2送气压力', value: null },
            { 'deviceId': '1da2d443-5d8c-4d36-bdd0-bd3eebe496a2', 'deviceName': '上游中跨进气夹2送气流量', value: null }
          ]
        },
        {
          name: '5#制备站上游中跨排气夹3',
          className: 'exhaust',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            { 'deviceId': 'a5f5b072-c37e-4aed-975d-8b61b3199c4d', 'deviceName': '上游中跨排气夹3送气湿度', value: null },
            { 'deviceId': '601406d2-e2c0-49ab-9698-64e49c531fb5', 'deviceName': '上游中跨排气夹3送气温度', value: null },
            { 'deviceId': 'dfe67307-7e82-42b0-8f08-7cf7708f8090', 'deviceName': '上游中跨排气夹3送气压力', value: null }
          ]
        },
        {
          name: '6#制备站上游中跨排气夹3',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            { 'deviceId': '528ff142-751c-4d8a-aaa4-b303216a41b9', 'deviceName': '上游中跨排气夹3送气湿度', value: null },
            { 'deviceId': 'cfd7c59e-b144-465d-b1c5-63cfe4fdbda9', 'deviceName': '上游中跨排气夹3送气温度', value: null },
            { 'deviceId': 'da6634fd-38c4-4d2e-9b91-3eb8e7a01753', 'deviceName': '上游中跨排气夹3送气压力', value: null }
          ]
        },
        {
          name: '6#制备站上游中跨进气夹2',
          className: 'supply',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            { 'deviceId': '6ada8bd8-0277-4b4c-bc33-4be487d0f5ca', 'deviceName': '上游中跨进气夹2送气湿度', value: null },
            { 'deviceId': '17d61e46-58f7-4526-a6b5-4267775bf555', 'deviceName': '上游中跨进气夹2送气温度', value: null },
            { 'deviceId': 'a07ac0ba-9767-4c9a-9b4d-25884266a447', 'deviceName': '上游中跨进气夹2送气压力', value: null },
            { 'deviceId': '74e88a59-19e6-4bcb-b9ef-894565f1fa04', 'deviceName': '上游中跨进气夹2送气流量', value: null }
          ],

        },
        {
          name: '6#制备站上游中跨排气夹2',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            { 'deviceId': 'bff7b32b-3c6a-4213-961b-9541fb21be48', 'deviceName': '上游中跨排气夹2送气湿度', value: null },
            { 'deviceId': '8b2434b3-296c-4052-81a1-398718698c47', 'deviceName': '上游中跨排气夹2送气温度', value: null },
            { 'deviceId': 'dd41e309-d0f7-4726-81e1-c6014772ebfe', 'deviceName': '上游中跨排气夹2送气压力', value: null }
          ]
        },
        {
          name: '6#制备站上游中跨进气夹1',
          className: 'supply',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            { 'deviceId': 'c3e45ddd-5bed-41ad-9bda-80beca0a21d0', 'deviceName': '上游中跨进气夹1送气湿度', value: null },
            { 'deviceId': 'd81b8432-2e3d-4841-bcbd-c881db6b7088', 'deviceName': '上游中跨进气夹1送气温度', value: null },
            { 'deviceId': '003ac826-f625-4ce5-b426-a8207aa86182', 'deviceName': '上游中跨进气夹1送气压力', value: null },
            { 'deviceId': '45816c70-b787-4880-bdb5-053336c0bfe3', 'deviceName': '上游中跨进气夹1送气流量', value: null }
          ]
        },
        {
          name: '6#制备站上游中跨排气夹1',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            { 'deviceId': '185da9d0-dd22-4357-b5f6-788e70e81655', 'deviceName': '上游中跨排气夹1送气湿度', value: null },
            { 'deviceId': 'baabd0c7-081a-4eb4-8236-4fd176a960f8', 'deviceName': '上游中跨排气夹1送气温度', value: null },
            { 'deviceId': 'dd48cd0c-5b9e-4428-a81c-a7d105fdc023', 'deviceName': '上游中跨排气夹1送气压力', value: null }
          ]
        },
        {
          name: '6#制备站上游边跨排气夹1',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            { 'deviceId': 'd287f893-968b-426a-9d35-81149b08588a', 'deviceName': '上游边跨排气夹1送气湿度', value: null },
            { 'deviceId': '3dcdf773-9717-42ce-af71-95db36352624', 'deviceName': '上游边跨排气夹1送气温度', value: null },
            { 'deviceId': '31b9388b-0c53-473c-943f-7e1d202d8536', 'deviceName': '上游边跨排气夹1送气压力', value: null }
          ]
        },
        {
          name: '6#制备站上游边跨进气夹',
          className: 'supply',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            { 'deviceId': 'a4f3df81-2d3b-480d-9b08-f19bcf49198c', 'deviceName': '上游边跨进气夹送气湿度', value: null },
            { 'deviceId': '5cc648c9-3ac7-4b4f-8d8a-712fa384f278', 'deviceName': '上游边跨进气夹送气温度', value: null },
            { 'deviceId': '9b6bcb23-e70e-411c-abae-e02bb67ead8d', 'deviceName': '上游边跨进气夹送气压力', value: null },
            { 'deviceId': '809d619b-d4b6-44a7-b16d-9479d367188b', 'deviceName': '上游边跨进气夹送气流量', value: null }
          ]
        },
        {
          name: '6#制备站上游边跨排气夹2',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            { 'deviceId': 'fbfdea68-5d86-4874-ab97-3e33014ae74a', 'deviceName': '上游边跨排气夹2送气湿度', value: null },
            { 'deviceId': '553ea198-d43a-48c4-a95c-6e34602e753d', 'deviceName': '上游边跨排气夹2送气温度', value: null },
            { 'deviceId': '41435625-c8ee-45cd-af22-adcc98e49160', 'deviceName': '上游边跨排气夹2送气压力', value: null }
          ]
        },
      ],
      bottomList: [
        {
          name: '5#制备站下游边跨排气夹2',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            { 'deviceId': '98d5ef63-2196-4c2f-950b-5c70ced6404f', 'deviceName': '下游边跨排气夹2送气湿度', value: null },
            { 'deviceId': '04ec0eb3-2364-4713-8a55-6ac2bd6e9ff1', 'deviceName': '下游边跨排气夹2送气温度', value: null },
            { 'deviceId': '433697ea-06be-4392-b510-2ad887823827', 'deviceName': '下游边跨排气夹2送气压力', value: null }
          ]
        },
        {
          name: '5#制备站下游边跨进气夹',
          className: 'supply',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            { 'deviceId': '75740742-558c-4e76-90ef-af37ed30736c', 'deviceName': '下游边跨进气夹送气湿度', value: null },
            { 'deviceId': '250659e1-b9f1-46ef-bdc8-71b1fe1df27c', 'deviceName': '下游边跨进气夹送气温度', value: null },
            { 'deviceId': '646d17fa-a15d-4c04-9192-b2946fc203ed', 'deviceName': '下游边跨进气夹送气压力', value: null },
            { 'deviceId': '636c5e8e-6939-4e25-9a36-db0348f59d8a', 'deviceName': '下游边跨进气夹送气流量', value: null }
          ]
        },
        {
          name: '5#制备站下游边跨排气夹1',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            { 'deviceId': 'fcec6d36-baa3-466e-b2e7-43b9b27830ba', 'deviceName': '下游边跨排气夹1送气湿度', value: null },
            { 'deviceId': 'b7537cbc-762e-4983-a284-f905735ce1a0', 'deviceName': '下游边跨排气夹1送气温度', value: null },
            { 'deviceId': '054d17fd-551f-4ce3-ab0a-b2b05014efdc', 'deviceName': '下游边跨排气夹1送气压力', value: null }
          ]
        },
        {
          name: '5#制备站下游中跨排气夹1',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            { 'deviceId': '745896ff-8de8-4997-9802-c3efd16dac78', 'deviceName': '下游中跨排气夹1送气湿度', value: null },
            { 'deviceId': '19ad1ed6-d0ff-4efb-b29a-794f1c15a7cf', 'deviceName': '下游中跨排气夹1送气温度', value: null },
            { 'deviceId': '7560402d-a21a-4df4-822d-563d4fb79a20', 'deviceName': '下游中跨排气夹1送气压力', value: null }
          ]
        },
        {
          name: '5#制备站下游中跨进气夹1',
          className: 'supply',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            { 'deviceId': 'a23e3880-3e2a-4c6e-aea5-03f9f5f6663c', 'deviceName': '下游中跨进气夹1送气湿度', value: null },
            { 'deviceId': 'abe17e35-0b51-4764-a94e-b29b183d6933', 'deviceName': '下游中跨进气夹1送气温度', value: null },
            { 'deviceId': '97fc735e-dda8-4161-afe4-dbaef80658b5', 'deviceName': '下游中跨进气夹1送气压力', value: null },
            { 'deviceId': '3c7f1ba9-ba0e-416b-b44a-dc23809b54bd', 'deviceName': '下游中跨进气夹1送气流量', value: null }
          ]
        },
        {
          name: '5#制备站下游中跨排气夹2',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            { 'deviceId': 'ac978c6f-31dc-4e3b-b96c-50ad709430db', 'deviceName': '下游中跨排气夹2送气湿度', value: null },
            { 'deviceId': '655ad179-752a-4474-bfff-6e9571cc96d4', 'deviceName': '下游中跨排气夹2送气温度', value: null },
            { 'deviceId': '6c80fd46-aba8-42ab-bdd4-1ab613bb17a9', 'deviceName': '下游中跨排气夹2送气压力', value: null }
          ]
        },
        {
          name: '5#制备站下游中跨进气夹2',
          className: 'supply',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            { 'deviceId': 'e8850c91-b137-4da7-89ef-17c9c5b17055', 'deviceName': '下游中跨进气夹2送气湿度', value: null },
            { 'deviceId': 'd4887616-7df0-44d9-9225-57f33eae7152', 'deviceName': '下游中跨进气夹2送气温度', value: null },
            { 'deviceId': 'cfd95ebd-fded-4ade-b73f-63f9b22fad25', 'deviceName': '下游中跨进气夹2送气压力', value: null },
            { 'deviceId': 'e6f49cf5-c657-4ff4-b22e-7fa0b2bd34fb', 'deviceName': '下游中跨进气夹2送气流量', value: null }
          ],

        },
        {
          name: '5#制备站下游中跨排气夹3',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            { 'deviceId': '880f00d9-3e9e-454e-97b2-a32103dd1ac6', 'deviceName': '下游中跨排气夹3送气湿度', value: null },
            { 'deviceId': 'fb213c8c-5dfc-4fd5-8b57-6955baded5ad', 'deviceName': '下游中跨排气夹3送气温度', value: null },
            { 'deviceId': '8ccdd9ed-76c5-405a-853c-4319dd31efcb', 'deviceName': '下游中跨排气夹3送气压力', value: null }
          ]
        },
        {
          name: '6#制备站下游中跨排气夹3',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            { 'deviceId': '7f901894-e729-4a7a-888a-cb18effc8fcc', 'deviceName': '下游中跨排气夹3送气湿度', value: null },
            { 'deviceId': 'f4a1ad82-df4a-4711-946a-6923a4e8c0a8', 'deviceName': '下游中跨排气夹3送气温度', value: null },
            { 'deviceId': '2feea05f-3848-45ec-bf52-7b56d1e577b7', 'deviceName': '下游中跨排气夹3送气压力', value: null }
          ],

        },
        {
          name: '6#制备站下游中跨进气夹2',
          className: 'supply',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            { 'deviceId': '936b3952-cd9f-472a-9063-fd5ddad368aa', 'deviceName': '下游中跨进气夹2送气湿度', value: null },
            { 'deviceId': 'f123733f-f80e-412c-a39c-bef8fbc5edf8', 'deviceName': '下游中跨进气夹2送气温度', value: null },
            { 'deviceId': 'a28f01be-930b-4c58-a720-75d5da00f997', 'deviceName': '下游中跨进气夹2送气压力', value: null },
            { 'deviceId': '9380d76c-f74a-465c-a664-3c685e70ed14', 'deviceName': '下游中跨进气夹2送气流量', value: null }
          ]
        },
        {
          name: '6#制备站下游中跨排气夹2',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            { 'deviceId': '5854d13d-ca46-4933-b601-1d93278eafc7', 'deviceName': '下游中跨排气夹2送气湿度', value: null },
            { 'deviceId': 'e364fbc8-7a96-4302-b412-7bc8a127cdad', 'deviceName': '下游中跨排气夹2送气温度', value: null },
            { 'deviceId': '691e4785-9f48-464f-8722-d2bbe0ff7f46', 'deviceName': '下游中跨排气夹2送气压力', value: null }
          ]
        },
        {
          name: '6#制备站下游中跨进气夹1',
          className: 'supply',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            { 'deviceId': 'fcc9e8d5-287c-4e8a-ac6e-412dea19f5e7', 'deviceName': '下游中跨进气夹1送气湿度', value: null },
            { 'deviceId': 'c3c8f16f-8bc9-4e94-9ab1-e880f32195e8', 'deviceName': '下游中跨进气夹1送气温度', value: null },
            { 'deviceId': '3ce752da-94b2-43de-bca3-f5db3381652a', 'deviceName': '下游中跨进气夹1送气压力', value: null },
            { 'deviceId': '4ec0e853-1987-47c7-804f-0d4190b21531', 'deviceName': '下游中跨进气夹1送气流量', value: null }
          ]
        },
        {
          name: '6#制备站下游中跨排气夹1',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            { 'deviceId': '0b33824d-1518-42fb-b941-be9d254961a7', 'deviceName': '下游中跨排气夹1送气湿度', value: null },
            { 'deviceId': 'b3137d75-fd21-49ab-a2df-40fd6d142f06', 'deviceName': '下游中跨排气夹1送气温度', value: null },
            { 'deviceId': 'd566834b-c418-41e2-a682-76d6d37cfd86', 'deviceName': '下游中跨排气夹1送气压力', value: null }
          ]
        },
        {
          name: '6#制备站下游边跨排气夹1',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            { 'deviceId': 'c4b4842d-7a4b-4eb5-809b-1d050ee017b3', 'deviceName': '下游边跨排气夹1送气湿度', value: null },
            { 'deviceId': 'fe3ccce0-19a2-4dd6-8c62-6ad8f8c4f8ea', 'deviceName': '下游边跨排气夹1送气温度', value: null },
            { 'deviceId': '482245b9-5d70-4234-ac2f-498c4ad90127', 'deviceName': '下游边跨排气夹1送气压力', value: null }
          ]
        },
        {
          name: '6#制备站下游边跨进气夹',
          className: 'supply',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            { 'deviceId': 'c150e837-350a-49d8-a423-af374f48c60c', 'deviceName': '下游边跨进气夹送气湿度', value: null },
            { 'deviceId': '28667c3f-9a7a-41a4-b339-91f340281876', 'deviceName': '下游边跨进气夹送气温度', value: null },
            { 'deviceId': '162c58c0-9231-4c89-a963-88f840e34a93', 'deviceName': '下游边跨进气夹送气压力', value: null },
            { 'deviceId': 'f4a13be8-9dd2-4ecb-8c9f-15797a028cf1', 'deviceName': '下游边跨进气夹送气流量', value: null }
          ]
        },
        {
          name: '6#制备站下游边跨排气夹2',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            { 'deviceId': '48660381-97a9-47b6-8bff-c0f018d77a1e', 'deviceName': '下游边跨排气夹2送气湿度', value: null },
            { 'deviceId': '388b4f02-85ca-4c55-ab77-11a815dcfd4d', 'deviceName': '下游边跨排气夹2送气温度', value: null },
            { 'deviceId': 'd9eac7c1-2981-4d33-a0e9-5ca842959b6f', 'deviceName': '下游边跨排气夹2送气压力', value: null }
          ]
        },
      ],
      timeFunc: null,
    }
  },
  created () {
    this.getDevice()
    this.timeFunc = setInterval(() => {
      this.getDevice()
    }, this.REFRESH_SECOND)
  },
  destroyed () {
    clearInterval(this.timeFunc)
    this.timeFunc = null
  },
  methods: {
    refreshData() {
      this.loading = true
      this.getDevice()
      clearInterval(this.timeFunc)
      this.timeFunc = setInterval(() => {
        this.getDevice()
      }, this.REFRESH_SECOND)
    },
    getDevice () {
      const oneHttp = this.$http.get(`/deviceData/Station?stationId=${this.deviceList[0].stationId}`)
      const twoHttp = this.$http.get(`/deviceData/Station?stationId=${this.deviceList[1].stationId}`)
      this.$http.all([oneHttp, twoHttp])
        .then(this.$http.spread((res1, res2) => {
          this.$store.commit('setLastRefreshTime')
          this.loading = false
          const resObject = Object.assign(res1.data || {}, res2.data || {})
          this.topList.forEach(val => {
            let errorLevelText = 'Normal'
            val.list.forEach(item => {
              const obj = resObject[item.deviceId]
              item.value = obj.value
              const errorLevel = obj.errorLevel
              if (errorLevelText !== 'Error') {
                if (errorLevel !== 'Normal') {
                  errorLevelText = errorLevel
                }
              }
            })
            val.errorLevel = errorLevelText
          })
          this.bottomList.forEach(val => {
            let errorLevelText = 'Normal'
            val.list.forEach(item => {
              const obj = resObject[item.deviceId]
              item.value = obj.value
              const errorLevel = obj.errorLevel
              if (errorLevelText !== 'Error') {
                if (errorLevel !== 'Normal') {
                  errorLevelText = errorLevel
                }
              }
            })
            val.errorLevel = errorLevelText
          })
        })
        )
    }
  }
}
</script>
<style scoped lang="scss">
.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
//  min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height:370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: flex-end;
      padding-bottom: 60px;

      .legend {
        position: absolute;
        left: 25px;
        top: 25px;

        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }

        .supply:after {
          background: #3376c7;
        }

        .exhaust:after {
          background: #c7798b;
        }

        .exhaust1:after {
          background: #f2bd42;
        }
      }

      .cable-img {
        position: relative;
        z-index: 0;
        width: 1400px;
        height: 180px;
        background: url("../../assets/image/qingshui/bridgeLine.png") no-repeat;

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;

          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }

          &:before {
            width: 50px;
          }

          &:after {
            width: 15px;
          }

          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

            & > p {
              margin: 0;
            }

            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }

            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }

            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }

          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }

          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }

          &.exhaust {
            background: #c7798b;

            &:after,
            &:before {
              background: #c7798b;
            }

            .state-info {
              background-color: rgba(253, 247, 250, 0.9);

              &:before {
                background-color: #c7798b;
              }
            }
          }

          &.supply {
            background: #3376c7;

            &:after,
            &:before {
              background: #3376c7;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #3376c7;
              }
            }
          }

          &.exhaust1 {
            background: #f2bd42;

            &:after,
            &:before {
              background: #f2bd42;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #f2bd42;
              }
            }
          }
        }

        .ex1 {
          top: 122px;
          left: 59px;

          &::before {
            bottom: -15px;
            left: -10px;
            transform: rotate(74deg);
          }

          &::after {
            bottom: -38px;
            left: 22px;
          }

          .state-info {
            left: 39px;
            top: 53px;
          }
        }

        .ex2 {
          top: 68px;
          left: 133px;

          &::before {
            top: -18px;
            left: -25px;
            transform: rotate(71deg);
          }

          &::after {
            top: -41px;
            left: -23px;
          }

          .state-info {
            right: 40px;
            top: -40px;
          }
        }

        .ex3 {
          top: 10px;
          left: 211px;

          &::before {
            top: -18px;
            left: -25px;
            transform: rotate(71deg);
          }

          &::after {
            top: -41px;
            left: -23px;
          }

          .state-info {
            right: 40px;
            top: -40px;
          }
        }

        .ex4 {
          top: 21px;
          left: 304px;

          &::before {
            bottom: -23px;
            left: -23px;
            transform: rotate(-79deg);
          }

          &::after {
            bottom: -46px;
            left: -18px;
          }

          .state-info {
            right: 36px;
            top: 60px;
          }
        }

        .ex5 {
          top: 38px;
          left: 385px;

          &::before {
            top: -23px;
            left: -11px;
            transform: rotate(-79deg);
          }

          &::after {
            top: -47px;
            right: -17px;
          }

          .state-info {
            left: 35px;
            top: -46px;
          }
        }

        .ex6 {
          top: 56px;
          left: 466px;

          &::before {
            bottom: -23px;
            left: -23px;
            transform: rotate(-79deg);
          }

          &::after {
            bottom: -46px;
            left: -18px;
          }

          .state-info {
            right: 36px;
            top: 60px;
          }
        }

        .ex7 {
          top: 72px;
          left: 564px;

          &::before {
            top: -23px;
            left: -11px;
            transform: rotate(-79deg);
          }

          &::after {
            top: -47px;
            right: -17px;
          }

          .state-info {
            left: 34px;
            top: -46px;
          }
        }

        .ex8 {
          top: 84px;
          left: 652px;

          &::before {
            bottom: -23px;
            left: -23px;
            transform: rotate(-79deg);
          }

          &::after {
            bottom: -46px;
            left: -18px;
          }

          .state-info {
            right: 36px;
            top: 60px;
          }
        }

        .ex9 {
          top: 84px;
          left: 729px;

          &::before {
            bottom: -23px;
            right: -23px;
            transform: rotate(79deg);
          }

          &::after {
            bottom: -46px;
            left: 18px;
          }

          .state-info {
            left: 35px;
            top: 60px;
          }
        }

        .ex10 {
          top: 72px;
          left: 816px;

          &::before {
            top: -23px;
            right: -11px;
            transform: rotate(79deg);
          }

          &::after {
            top: -47px;
            left: -17px;
          }

          .state-info {
            right: 35px;
            top: -46px;
          }
        }

        .ex11 {
          top: 56px;
          left: 915px;

          &::before {
            bottom: -23px;
            right: -23px;
            transform: rotate(79deg);
          }

          &::after {
            bottom: -46px;
            left: 18px;
          }

          .state-info {
            left: 35px;
            top: 60px;
          }
        }

        .ex12 {
          top: 38px;
          left: 994px;

          &::before {
            top: -23px;
            right: -11px;
            transform: rotate(79deg);
          }

          &::after {
            top: -47px;
            left: -17px;
          }

          .state-info {
            right: 35px;
            top: -46px;
          }
        }

        .ex13 {
          top: 21px;
          left: 1075px;

          &::before {
            bottom: -23px;
            right: -23px;
            transform: rotate(79deg);
          }

          &::after {
            bottom: -46px;
            left: 18px;
          }

          .state-info {
            left: 35px;
            top: 60px;
          }
        }

        .ex14 {
          top: 10px;
          left: 1170px;

          &::before {
            top: -18px;
            right: -25px;
            transform: rotate(-71deg);
          }

          &::after {
            top: -41px;
            right: -23px;
          }

          .state-info {
            left: 41px;
            top: -41px;
          }
        }

        .ex15 {
          top: 68px;
          left: 1247px;

          &::before {
            top: -18px;
            right: -25px;
            transform: rotate(-71deg);
          }

          &::after {
            top: -41px;
            right: -23px;
          }

          .state-info {
            left: 41px;
            top: -40px;
          }
        }

        .ex16 {
          top: 122px;
          left: 1320px;

          &::before {
            bottom: -15px;
            right: -10px;
            transform: rotate(-74deg);
          }

          &::after {
            bottom: -38px;
            right: 22px;
          }

          .state-info {
            right: 39px;
            top: 53px;
          }
        }
      }
    }
  }
}
</style>
